// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"elements_wrapper__Se8iy","headerBase":"elements_headerBase__I4lQ0","headerCloneWrapper":"elements_headerCloneWrapper__qlsYf"};